<template>
    <ul class="nav navbar-nav float-right be-user-nav" v-if="isAuthenticated">
        <li class="nav-item" v-dropdown>
            <a class="nav-link d-flex align-items-center" style="height: 60px" href="#" @click.stop>
                <avatar :username="`${user.firstname} ${user.lastname}`" :src="user.avatarSmall" :size="32"/>
                <span class="user-name">{{user.firstname}} {{user.lastname}}</span>
            </a>
            <div>
                <div class="user-info">
                    <div class="user-name">{{user.firstname}} {{user.lastname}}</div>
                    <!--<div class="user-position online">Available</div>-->
                </div>
                <router-link :to="{ name: 'user-profile' }" class="dropdown-item"><span class="icon mdi mdi-face"></span>Profil</router-link>
                <router-link :to="{ name: 'user-password' }" class="dropdown-item"><span class="icon mdi mdi-key"></span>Passwort ändern</router-link>
                <!--<a class="dropdown-item" href="#"><span class="icon mdi mdi-settings"></span>Settings</a>-->

                <a class="dropdown-item" href="#" @click.prevent="switchBack" v-if="hasPreviousUser"><span class="icon mdi mdi-power"></span>Zurück zu {{previousUser.firstname}} {{previousUser.lastname}}</a>
                <a class="dropdown-item" href="#" @click.prevent="logout" v-else><span class="icon mdi mdi-power"></span>Logout</a>
            </div>
        </li>
    </ul>
    <ul class="nav navbar-nav float-right" v-else>
        <router-link :to="{ name: 'login', query: { redirect: $route.fullPath } }" tag="li" class="nav-item">
            <span class="nav-link"><a :class="buttonClass"><i class="icon icon-left mdi mdi-lock"></i> App Login</a></span>
        </router-link>
    </ul>
</template>


<script>
    import { mapGetters } from 'vuex';
    import env from '../../mixins/env';

    export default {
        mixins: [env],

        computed: {
            ...mapGetters('user', ['user', 'isAuthenticated', 'hasPreviousUser', 'previousUser']),

            buttonClass() {
                return {
                    'btn btn-lg ml-2': true,
                    'btn-info': !this.isGrfSystem && !this.isHeidilandSystem,
                    'btn-primary': this.isGrfSystem,
                    'btn-light': this.isHeidilandSystem,
                };
            },
        },

        methods: {
            async logout() {
                this.$router.push({ name: 'home' });
                this.$store.dispatch('user/logout');
            },

            async switchBack() {
                this.$store.dispatch('user/switchBack');
                this.$router.push({ name: 'home' });
            },
        },
    };
</script>


<style lang="scss">
    .be-user-nav {
        .vue-avatar {
            display: flex !important;
        }

        .user-name {
            flex: auto !important;
        }

        > li.dropdown .dropdown-menu {
            width: auto;
            left: 42px;
            transform: translateX(-100%);
        }
    }
</style>
